import DotNetObject = DotNet.DotNetObject;
import { PermissionCrmContactGroup } from '@crimsontide/core/client/interfaces';

export const PermissionCrmContactGroupService = (() => {
  let dotNetObj: DotNetObject;
  let cachedPermissionCrmContactGroups: PermissionCrmContactGroup[];

  const setDotNetReference = (obj: DotNetObject): void => {
    dotNetObj = obj;
  };

  const getPermissionCrmContactGroups = async (useCache: boolean = true): Promise<PermissionCrmContactGroup[]> => {
    if (useCache && cachedPermissionCrmContactGroups != null)
      return cachedPermissionCrmContactGroups;

    if (dotNetObj) {
      cachedPermissionCrmContactGroups = await dotNetObj.invokeMethodAsync<PermissionCrmContactGroup[]>('GetPermissionCrmContactGroupsAsync');
      return cachedPermissionCrmContactGroups;
    } else {
      throw 'PermissionCrmContactGroupService DotNet Object Reference has not yet been implemented';
    }
  };

  return {
    setDotNetReference,
    getPermissionCrmContactGroups,
  };
})();
